module.exports = __webpack_public_path__ + "static/media/vaccine_p3_2.5be0f8a2.png";